// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".col {\n    background-color: #F1FAEE;\n    font-size: 2rem;\n}\n\n.titulo {\n    background-color: #F1FAEE;\n \n}\n\n", "",{"version":3,"sources":["webpack://src/css/admin.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;;AAE7B","sourcesContent":[".col {\n    background-color: #F1FAEE;\n    font-size: 2rem;\n}\n\n.titulo {\n    background-color: #F1FAEE;\n \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
